export default "__VITE_ASSET__BSZVcc0D__"